import moment from "moment";

export const parseDate = (date) => {
  if (date === "" || date === null || date === undefined) return "-";
  else return moment(date).format("DD/MM/yyyy");
};
